// remotion/src/helpers/timeline.ts
//
// All phase frame constants for the PhotoParsingScene composition
// (30 fps, 150 frames = 5 s). Single source of truth — Phone,
// Whiteboard, TimerPopUp, ScreenshotOverlay import from here.
//
// Timeline (5 s total — every beat scaled 5/7 from the prior 7 s cut):
//   0–4    blank lead-in
//   4–18   phone slides in from left
//   7–21   whiteboard slides in (near-simultaneous with phone)
//   18–29  cursor enters; starts before the board lands
//   29–46  cursor drags a selection rectangle across the board
//   46–50  selection snaps into a captured "screenshot" thumbnail
//   50–75  cursor drags the screenshot toward the phone
//   32     count-up clock begins ticking (~1.4 s pre-tick before the
//          timer becomes visible)
//   75     timer starts sliding in from off-screen right
//   75     phone begins 360° twist around its long axis ("loading")
//   81     phone screen swaps to timer-ready (mid-spin, hidden by back)
//   88     phone twist completes — new image already visible on return
//   89     timer settles at the target slot
//   89–150 timer count-up continues

// --- Stage entry ---------------------------------------------------------
export const PHONE_SLIDE_IN_START_FRAME = 4;
export const PHONE_SLIDE_IN_END_FRAME = 18;

// Whiteboard kicks in shortly after the phone starts so both pieces of
// "stage furniture" arrive together rather than in a long staggered
// sequence.
export const WHITEBOARD_SLIDE_IN_START_FRAME = 7;
export const WHITEBOARD_SLIDE_IN_END_FRAME = 21;

// --- Cursor + screenshot interaction -------------------------------------
// Cursor enters slightly BEFORE the whiteboard finishes its slide so the
// screenshot ritual already feels in motion as the board arrives.
export const CURSOR_ENTER_START_FRAME = 18;
export const CURSOR_ENTER_END_FRAME = 29;

export const SELECTION_START_FRAME = 29;
export const SELECTION_END_FRAME = 46;

export const CAPTURE_FRAME = 50;

export const DRAG_START_FRAME = 54;
export const DRAG_END_FRAME = 75;

// --- Processing window ---------------------------------------------------
// Loading window covers the timer's slide-in so the spinner-equivalent
// (the phone's 360° twist) is on-screen while the timer is travelling.
export const PROCESSING_START_FRAME = 75;
export const PROCESSING_END_FRAME = 88;

// --- Phone receives the screenshot ---------------------------------------
// Screen swap is timed to the MIDDLE of the phone's 360° loading spin —
// at the halfway point the phone's back is facing the camera, so the
// swap is invisible. By the time the phone rotates back around to face
// the camera, the new (timer-ready) image is already on the screen.
export const PHONE_SCREEN_SWAP_FRAME = Math.floor(
  (PROCESSING_START_FRAME + PROCESSING_END_FRAME) / 2,
);
export const PHONE_GLOW_START_FRAME = PROCESSING_END_FRAME - 3;
export const PHONE_GLOW_PEAK_OFFSET = 6;
export const PHONE_GLOW_END_OFFSET = 18;

// --- Timer ---------------------------------------------------------------
// Timer slides in during the loading window — kicks off at the same
// frame the loading beat starts. 14-frame duration matches the
// whiteboard slide-in (5/7 of the prior 20-frame slide).
export const TIMER_POP_UP_FRAME = 75;
export const TIMER_TRAVEL_END_FRAME = 89;

// Count-up begins ~43 frames (~1.4 s @ 30 fps) BEFORE the timer
// materialises — the timer is invisible during that pre-run, so by the
// time it slides into view it already reads ~00:00:01 instead of
// starting from 00:00:00.
export const TIMER_COUNT_START_FRAME = TIMER_POP_UP_FRAME - 43;
